import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import styles from './../../../../Styles';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import ViewListIcon from '@material-ui/icons/ViewList';
import distortion_sl_init from './../images/distortion_sl_init.png';
import distortion_sl_active from './../images/distortion_sl_active.png';
import distortion_sl_results from './../images/distortion_sl_results.png';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const INITIAL_STATE = {
    open: false,
    legendOpen: false
};

class HostInstructions extends Component {

    constructor(props) {
        super(props);
        this.state = {
          ...INITIAL_STATE,
        };
    }

    handleClickOpen = () => {
        this.setState({
            ...this.state,
            open: true
        });
    };
    
    handleClose = () => {
        this.setState({
            ...this.state,
            open: false
        });
    };

    handleLegendClickOpen = () => {
        this.setState({
            ...this.state,
            legendOpen: true
        });
    };
    
    handleLegendClose = () => {
        this.setState({
            ...this.state,
            legendOpen: false
        });
    };

    render() {
        const {
        classes,
        } = this.props;

        return (
        <div>
            <Typography variant='h5' className={classes.greyText}>
                Host Tools
            </Typography>
            <div className={classes.spacingTop}>
                <div><Button 
                        variant="contained"
                        color="primary"
                        startIcon={<SpeakerNotesIcon />}
                        onClick={this.handleClickOpen}
                        >
                    Leader Notes
                    </Button>
                    <div className={classes.spacingTop}>
                        <Button 
                            variant="contained"
                            color="primary"
                            startIcon={<ViewListIcon />}
                            onClick={this.handleLegendClickOpen}
                            >
                        State Legend
                        </Button>
                    </div>
                </div>
            </div>
            <Dialog open={this.state.open} onClose={this.handleClose} TransitionComponent={Transition}>
                <AppBar position="static">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                    <CloseIcon />
                    </IconButton>
                        <Typography variant="h6" className={classes.boldedText}>
                        Leader Notes
                        </Typography>                    
                </Toolbar>
                </AppBar>
                <Grid container spacing={2} className={classes.dialogueGrid}>
                    <Grid item xs={12}  className={classes.spacingTop}>
                        <div className={classes.bodyText}>   
                            <div className={classes.boldedText}>Distortion - Exercise</div>
                            <ul className={classes.properList}>
                                <li className={classes.properListItem}>3-4 on a team. Seated Engineer, Contractor, Standing Engineer(s) (1-2)</li>
                                <li className={classes.properListItem}>Engineer and contractor sit back to back</li>
                                <li className={classes.properListItem}>Keep your materials hidden from the other person</li>
                                <li className={classes.properListItem}>Standing engineer must stay out of the line of sight of the contractor and seated engineer</li>
                                <li className={classes.properListItem}>Standing engineer may not communicate verbally or non-verbally</li>
                                <li className={classes.properListItem}>Call out when you are finished</li>
            
                            </ul>
                            <br/>
                            <div className={classes.boldedText}>Debrief Round 1</div>
                            <ul className={classes.properList}>
                                <li className={classes.properListItem}>Contractors, what was your role like in this exercise?</li>
                                <li className={classes.properListItem}>Seated Engineers, how did you feel in this exercise?</li>
                                <li className={classes.properListItem}>Standing Engineers, how did you feel in this exercise?</li>            
                            </ul>
                            <br/>
                            <div className={classes.boldedText}>Debrief</div>
                            <ul className={classes.properList}>
                                <li className={classes.properListItem}>What were the things that you had no control over in that first round?</li>
                                <li className={classes.properListItem}>What did you have control over?</li>
                                <li className={classes.properListItem}>Talk at your table.</li>            
                            </ul>
                            <br/>
                            <div className={classes.boldedText}>Did not have control</div>
                            <ul className={classes.properList}>
                                <li className={classes.properListItem}>Interpretation of the instructions</li>
                                <li className={classes.properListItem}>Nothing!</li>
                                <li className={classes.properListItem}>Time</li>
                                <li className={classes.properListItem}>Language</li>
                                <li className={classes.properListItem}>Rules</li>
                                <li className={classes.properListItem}>Language of geometry</li>
                                <li className={classes.properListItem}>Orientation</li>
                            </ul>
                            <br/>
                            <div className={classes.boldedText}>What did you have control over?</div>
                            <ul className={classes.properList}>
                                <li className={classes.properListItem}>Tapping in</li>
                                <li className={classes.properListItem}>Amount of questions the contractor could ask</li>
                                <li className={classes.properListItem}>Movement</li>
                            </ul>
                            <br/>
                            <div className={classes.boldedText}>Round 2</div>
                            <ul className={classes.properList}>
                                <li className={classes.properListItem}>How will you improve your process, take control and cut your time in half?</li>
                            </ul>                            
                            <br/>
                            <div className={classes.boldedText}>Prepare for Round 2 - Ideas</div>
                            <ul className={classes.properList}>
                                <li className={classes.properListItem}>Use common language</li>
                                <li className={classes.properListItem}>Tap in frequently</li>
                                <li className={classes.properListItem}>Affirm the speaker</li>
                                <li className={classes.properListItem}>Use words picture to make the complex simple</li>
                                <li className={classes.properListItem}>Give the big picture upfront</li>
                                <li className={classes.properListItem}>Do frequent understanding checks</li>
                                <li className={classes.properListItem}>Plan to understand</li>
                                <li className={classes.properListItem}>Ask questions</li>
                            </ul>
                            <br/>
                            <div className={classes.boldedText}>Strategize what ideas you will implement and how you will cut your time in half</div>
                            <br/>
                            <div className={classes.boldedText}>Round 2 Debrief</div>
                            <ul className={classes.properList}>
                                <li className={classes.properListItem}>How did you improve your process to improve your time and ensure understanding?</li>
                                <li className={classes.properListItem}>What did you not have control over?</li>
                                <li className={classes.properListItem}>What did you have control over?</li>
                            </ul>
                        </div>                     
                    </Grid>
                </Grid>
                                  
            </Dialog>
            <Dialog  open={this.state.legendOpen} onClose={this.handleLegendClose} TransitionComponent={Transition}>
                <AppBar position="static">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={this.handleLegendClose} aria-label="close">
                    <CloseIcon />
                    </IconButton>
                        <Typography variant="h6" className={classes.boldedText}>
                        State Legend
                        </Typography>                    
                </Toolbar>
                </AppBar>
                <Grid container spacing={2} className={classes.dialogueGrid}>
                    <Grid item xs={12}  className={classes.spacingTop}>
                        <Typography variant="body1" className={`${classes.boldedText} ${classes.spacingTop}`}>Init</Typography>
                        <div>
                            <img src={distortion_sl_init} alt='intro graphic and assign roles' className={`${classes.imageSize} ${classes.borderImage}`}/>
                        </div>
                        <Typography variant="body1" className={`${classes.boldedText} ${classes.spacingTop}`}>Active</Typography>
                        <div>
                            <img src={distortion_sl_active} alt='distortion game screen' className={`${classes.imageSize} ${classes.borderImage}`}/>
                        </div>
                        <Typography variant="body1" className={`${classes.boldedText} ${classes.spacingTop}`}>Results</Typography>
                        <div>
                            <img src={distortion_sl_results} alt='wrapping up and waiting for others' className={`${classes.imageSize} ${classes.borderImage}`}/>
                        </div> 
                    </Grid>
                </Grid>                   
            </Dialog>
        </div>
        );
    }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(HostInstructions);